
import { Routes, Route, Navigate } from 'react-router-dom';
import PublicRoutes from '@/routes/PublicRoutes';
import AdminRoutes from '@/routes/AdminRoutes';

export default function App() {
  return (
    <Routes>
      <Route path="/*" element={<PublicRoutes />} />
      <Route path="/administrator/*" element={<AdminRoutes />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
